import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { AlertOptions, LoadingOptions, ToastOptions } from '@ionic/core';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {

  constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController
  ) { }

  processAlertHtml(alert: HTMLIonAlertElement): void {
    // Aguarda o próximo ciclo de renderização
    setTimeout(() => {
      try {
        const alertWrapper = alert.querySelector('.alert-wrapper');
        if (!alertWrapper) return;

        const messageElement = alertWrapper.querySelector('.alert-message') as HTMLElement;
        if (!messageElement) return;

        const originalContent = messageElement.textContent || messageElement.innerHTML || '';
        
        // Verifica se há tags HTML na mensagem
        if (this.containsHtmlTags(originalContent)) {
          // Converte quebras de linha HTML
          const htmlContent = originalContent
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/<br\s*\/?>/gi, '<br>')
            .replace(/\n/g, '<br>');
          
          messageElement.innerHTML = htmlContent;
        }
      } catch (error) {
        console.warn('Erro ao processar HTML do alerta:', error);
      }
    }, 50);
  }

  private containsHtmlTags(text: string): boolean {
    const htmlTagRegex = /<[^>]*>/;
    return htmlTagRegex.test(text);
  }


  async alert(options?: AlertOptions): Promise<HTMLIonAlertElement> {
    const alert = await this.alertCtrl.create(options);
    this.processAlertHtml(alert);
    await alert.present();
       
    
    return alert;
  }

  async loading(options?: LoadingOptions): Promise<HTMLIonLoadingElement> {
    const loading = await this.loadingCtrl.create({
      message: 'Carregando...',
      ...options
    });
    await loading.present();
    return loading;
  }

  async toast(options?: ToastOptions): Promise<HTMLIonToastElement> {
    const toast = await this.toastCtrl.create({
      position: 'bottom',
      duration: 3000,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {

          }
        }
      ],
      ...options
    });

    await toast.present();
    return toast;
  }

  // async present(options?: ) {
  //   const alert = await this.alertCtrl.create({
  //     header: 'Confirmação..',
  //     message: 'Confirma?',
  //     buttons: [
  //       {
  //         text: 'Cancela',
  //         role: 'cancel',          
  //       }, {
  //         text: 'Okay',
  //         handler: () => {
  //           ...
  //         }
  //       }
  //     ]
  //   });

  //   await alert.present();
  // }
}
